'use client'

import { useState, useTransition } from 'react'
import { ProductType } from '../product-shops/ShopList'
import { useShoppingCart } from 'use-shopping-cart'

type Props = {
  product: ProductType
}

enum Action {
  Increment,
  Decrement
}

export default function AddToCart({ product }: Props) {
  const [isPending, startTransition] = useTransition()
  const [quantity, setQuantity] = useState(1)
  const { addItem } = useShoppingCart()

  const handleQuantity = (action: Action) => {
    switch (action) {
      case Action.Increment:
        if (quantity >= 10) return
        setQuantity(quantity + 1)
        break
      case Action.Decrement:
        if (quantity <= 1) return
        setQuantity(quantity - 1)
        break
    }
  }

  const handleAddToCart = () => {
    addItem(
      {
        id: product.id,
        name: product.name,
        title: product.name,
        price: product.price,
        currency: product.currency,
        image: product.image_url,
        imageAlt: product.imageAlt,
        productId: product.id,
      },
      { count: quantity }
    )
  }

  return (
    <>
      <div className="w-full flex flex-row justify-center border rounded-lg">
        <button
          data-action="decrement"
          className="h-full w-20 cursor-pointer outline-none py-3"
          onClick={() => handleQuantity(Action.Decrement)}
          aria-label={`Remover ${product.name}`}
        >
          <span className="m-auto text-base">−</span>
        </button>
        <input
          type="number"
          className="text-center w-full text-base hover md:text-base cursor-default flex items-center outline-none bg-transparent"
          readOnly
          value={quantity}
        />
        <button
          data-action="increment"
          className="h-full w-20 cursor-pointer py-3"
          onClick={() => handleQuantity(Action.Increment)}
          aria-label={`Adicionar ${product.name}`}
        >
          <span className="m-auto text-base">+</span>
        </button>
      </div>

      <button
        aria-label="Adicionar ao carrinho"
        title="Adicionar ao carrinho"
        disabled={isPending}
        className="w-full border mt-4 py-2 px-8 rounded-lg hover:bg-black hover:text-white"
        onClick={handleAddToCart}
      >
        <span>Adicionar ao carrinho</span>
      </button>
    </>
  )
}
